import React from 'react';
import { ShieldAlert } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';

export const BaaReminder = ({ open, onOpenChange, canSign, onGo }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="baa-modal" className="max-w-md">
      <div className="flex flex-col items-center text-center gap-3 pt-2">
        <div className="w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center">
          <ShieldAlert className="w-7 h-7 text-amber-600" />
        </div>
        <DialogTitle className="text-xl font-bold text-slate-900">Please sign your BAA</DialogTitle>
        <DialogDescription className="text-sm text-slate-600">
          Your practice needs to sign the HIPAA Business Associate Agreement with The OnCall Bot LLC d/b/a PractCom.
          Sending patient documents and messages (Dictate Visit, portal links, texts and emails) is paused until it's signed.
        </DialogDescription>
        {canSign ? (
          <Button onClick={onGo} data-testid="baa-go-to-settings" className="w-full h-11 rounded-full bg-[#0b2545] hover:bg-[#13315c] text-white font-semibold mt-2">
            Go to Practice Settings to sign
          </Button>
        ) : (
          <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg p-3" data-testid="baa-staff-notice">
            Only your practice administrator can sign it. Please ask them to sign in Practice Settings.
          </p>
        )}
        <button type="button" onClick={() => onOpenChange(false)} data-testid="baa-sign-later" className="text-sm text-slate-500 hover:text-slate-800 underline underline-offset-4">
          Remind me later
        </button>
      </div>
    </DialogContent>
  </Dialog>
);
